import axios from "axios";
/*
  For Development : dev
  For Testing env : test
  For Production Stage  : stage-prod
  For Production  : prod
*/
const status = "prod";
// export const awsUrl = "https://gmfceyt8p9.execute-api.ap-south-1.amazonaws.com/test";
export const awsUrl =
  "https://kgi992skq6.execute-api.ap-south-1.amazonaws.com/" + status;
const awsUrlS3 = "https://jkzdxlws1i.execute-api.ap-south-1.amazonaws.com/prod";
const elasticURL =
  "https://search-rhealth-prod-d53qbfwui7ffwcaelbhygfdlq4.ap-south-1.es.amazonaws.com";

const aiUrl =
  "https://0t4e1scfle.execute-api.ap-south-1.amazonaws.com/prod/ai-interview";

export function backendApiForInterviewQtn(postData) {
  return axios
    .post(aiUrl, postData)
    .then((data) => data.data)
    .then((res) => res);
}

export function backendApi(postData) {
  return axios
    .post(awsUrl, postData)
    .then((data) => data.data)
    .then((res) => res);
}
export const re =
  /^[a-zA-Z0-9+_.-]+@(?!gmail.com)(?!outlook.com)(?!rediffmail.com)(?!hotmail.com)(?!yahoo.com)(?!aol.com)(?!msn.com)[a-zA-Z0-9.-]+$/;
export const emailValidation =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const urlPattern = /^(https?:\/\/)?([\w-]+(\.[\w-]+)+)(:\d+)?(\/\S*)?$/;
export const phNum = /^\d{10}$/;

export function backendApiS3Credential(postData) {
  return axios
    .post(awsUrlS3, postData)
    .then((data) => data.data)
    .then((res) => res);
}

//! ------------------------Image Upload API-------------------------------
export function UploadImage(image) {
  return axios
    .post(
      `${imageUploadURL}newUpload?bucket=${process.env.REACT_APP_S3_BUCKET}&bucketPath=${process.env.REACT_APP_BUCKET_PATH}`,
      image,
    )
    .then((data) => data)
    .then((res) => res);
}

//! Image Upload URL

const imageUploadURL =
  "https://75vfqs60v3.execute-api.ap-south-1.amazonaws.com/";

const generateFileName = () => {
  return `${uuidv4()}-${Date.now()}`;
};
const uuidv4 = () => {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0,
      v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

export const uploadToS3 = async (blob) => {
  try {
    const fileName = generateFileName();
    const formData = new FormData();
    formData.append("image", blob, fileName + blob.name);
    const data = await UploadImage(formData);
    return data.data.imageUrl;
  } catch (error) {
    console.error("Upload failed:", error);
    throw error;
  }
};
